// ----------------------------------------------------------------------

export default function IconButton(theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            color: theme.palette.grey[600],
            border: "inherited",
            backgroundColor: "inherited",
          },
          "&:focus": {
            backgroundColor: "transparent",
            color: theme.palette.grey[600],
          },
        },
      },
    },
  };
}
